module.exports = __webpack_public_path__ + "img/en-pc-step-3.3aaef4c7.png";